export default __webpack_public_path__ + "static/media/register.270edb26.svg";